"use client";

import { Button } from "@/components/ui/Button";
import { useAtom } from "jotai";
import { useLayoutEffect } from "react";
import { selectedGroupAtom } from "../../config";
import styles from "./AccordionGroupsFilterBar.module.css";

export interface AccordionGroupsFilterBarProps {
	groups: string[];
}

export const AccordionGroupsFilterBar = ({ groups }: AccordionGroupsFilterBarProps) => {
	const [selectedGroup, setSelectedGroup] = useAtom(selectedGroupAtom);

	useLayoutEffect(() => {
		if (groups.length > 0 && selectedGroup === undefined) {
			setSelectedGroup(groups[0]);
		}
	}, [groups, selectedGroup, setSelectedGroup]);

	return (
		<div className={styles.root}>
			{groups.map((group, key) => (
				<Button
					key={key}
					variant="filter"
					selected={selectedGroup === group}
					onClick={() => {
						setSelectedGroup(group);
					}}
					className={styles.button}
				>
					{group}
				</Button>
			))}
		</div>
	);
};
